// Content from the supplied standalone. Option positions are UI positions, not API IDs or an answer key.
export interface KnowledgeQuestion {
  text: string;
  options: string[];
}
export const knowledgeQuestions: KnowledgeQuestion[] = [
  {
    text: "Есть ли у Вас опыт совершения операций с виртуальными активами?",
    options: ["Да", "Нет"],
  },
  {
    text: "Знаете ли Вы, что такое виртуальный актив (криптовалюта)?",
    options: ["Да", "Нет"],
  },
  {
    text: "Какое определение виртуального актива является наиболее корректным?",
    options: [
      "Данные в электронно-цифровой форме, имеющие стоимость и обращающиеся в цифровой среде, но не являющиеся национальной валютой или ценной бумагой сами по себе",
      "Любая иностранная валюта в электронном виде",
      "Любая банковская карта или электронный кошелек",
      "Государственная ценная бумага в цифровой форме",
    ],
  },
  {
    text: "Может ли стоимость виртуального актива существенно измениться за короткий период?",
    options: [
      "Да, цена может как значительно вырасти, так и значительно снизиться",
      "Нет, стоимость виртуальных активов фиксирована государством",
      "Нет, снижение возможно только после разрешения оператора",
      "Стоимость всегда изменяется только в сторону роста",
    ],
  },
  {
    text: "Что означает необратимость блокчейн-транзакции?",
    options: [
      "После подтверждения перевод, как правило, нельзя отменить по аналогии с банковским платежом; ошибка в адресе или сети может привести к утрате активов",
      "Любую транзакцию можно отменить в течение 24 часов",
      "Оператор обязан вернуть активы при любой ошибке клиента",
      "Транзакция автоматически отменяется при изменении курса",
    ],
  },
  {
    text: "Что необходимо проверить перед отправкой виртуального актива?",
    options: [
      "Адрес получателя, выбранную сеть, вид актива и сумму операции",
      "Только имя получателя",
      "Только текущий курс актива",
      "Только баланс своего кошелька",
    ],
  },
  {
    text: "Как следует поступить, если третье лицо просит сообщить пароль, seed-фразу или приватный ключ от криптокошелька?",
    options: [
      "Не сообщать эти данные и прекратить взаимодействие при подозрении на мошенничество",
      "Сообщить, если лицо представилось сотрудником сервиса",
      "Сообщить только часть seed-фразы",
      "Отправить данные в мессенджере, если аккаунт выглядит официальным",
    ],
  },
  {
    text: "Гарантирует ли ОсОО «Асикс» получение прибыли от покупки или обмена виртуальных активов?",
    options: [
      "Нет, прибыль не гарантируется, а стоимость актива может снизиться вплоть до существенной или полной потери вложенных средств",
      "Да, если операция совершена через платформу",
      "Да, для наиболее известных криптовалют",
      "Да, если клиент прошел идентификацию",
    ],
  },
  {
    text: "Какие риски могут быть связаны с операциями с виртуальными активами? Выберите наиболее полный ответ.",
    options: [
      "Волатильность, технические сбои, мошенничество, хакерские атаки, ошибки при выборе адреса/сети и возможная утрата активов",
      "Только изменение курса",
      "Только технические сбои платформы",
      "Риски отсутствуют после прохождения KYC",
    ],
  },
  {
    text: "Почему Компания может запросить документы о происхождении денежных средств/виртуальных активов или дополнительную информацию по операции?",
    options: [
      "Для выполнения требований идентификации, ПОД/ФТ, AML/KYT и оценки риска операции",
      "Только для рекламной рассылки",
      "Чтобы гарантировать клиенту доходность",
      "Чтобы изменить курс виртуального актива",
    ],
  },
  {
    text: "Может ли операция быть приостановлена, ограничена или отклонена при выявлении повышенного AML/KYT-риска, санкционных или иных подозрительных признаков?",
    options: [
      "Да",
      "Нет",
      "Только по желанию клиента",
      "Только после изменения курса актива",
    ],
  },
  {
    text: "Что из перечисленного является виртуальным активом?",
    options: [
      "Bitcoin (BTC)",
      "Кыргызский сом (KGS)",
      "Доллар США (USD)",
      "Банковский депозит в сомах",
    ],
  },
];
export const knowledgeAssessmentRules =
  "Вопросы 1–2 носят информационный характер и не влияют на итоговый балл. Вопросы 3–12 оцениваются по 1 баллу за каждый правильный ответ. Рекомендуемый порог достаточного уровня знаний — не менее 8 правильных ответов из 10. При результате ниже установленного порога клиенту не предоставляется доступ к операциям до повторного тестирования после ознакомления с информацией о виртуальных активах и рисках.";
export const knowledgeRisks = [
  "виртуальные активы могут не являться законным платежным средством и не обеспечиваются государством;",
  "стоимость виртуальных активов подвержена значительным колебаниям; возможна существенная или полная потеря средств, переданных в обмен на виртуальные активы;",
  "операции могут сопровождаться технологическими, сетевыми, операционными, правовыми, мошенническими и киберрисками;",
  "передача третьим лицам паролей, seed-фраз, приватных ключей и иных конфиденциальных данных может привести к утрате активов;",
  "блокчейн-транзакции после подтверждения, как правило, необратимы; ошибка в адресе, сети, виде актива или сумме может привести к невозможности возврата;",
  "ОсОО «Асикс» вправе проводить KYC/CDD/EDD, санкционный скрининг и AML/KYT-проверки, запрашивать дополнительные документы и сведения, а также ограничивать, приостанавливать или отклонять операции в случаях, предусмотренных законодательством и внутренними документами Компании;",
  "ОсОО «Асикс» не гарантирует доходность, сохранение стоимости или отсутствие убытков при совершении операций с виртуальными активами.",
];
